import { EventEmitter } from '@angular/core';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import * as Sentry from '@sentry/browser';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonConstant } from '../../../app.constants';
export var InfluencerDemographicGender;
(function (InfluencerDemographicGender) {
    InfluencerDemographicGender["Female"] = "Female";
    InfluencerDemographicGender["Male"] = "Male";
})(InfluencerDemographicGender || (InfluencerDemographicGender = {}));
var InfluencerDemographicsComponent = /** @class */ (function () {
    function InfluencerDemographicsComponent(userService, referenceDataService, translate, pdfService) {
        this.userService = userService;
        this.referenceDataService = referenceDataService;
        this.translate = translate;
        this.pdfService = pdfService;
        this.afterViewInit = new EventEmitter();
        // items placeholder for brand
        this.placeholderItems = new Array(15);
    }
    /**
     * get max percent number of GenderPerAge data
     * @param data
     */
    InfluencerDemographicsComponent.getMaxPercentOfGenderPerAge = function (data) {
        var femaleArray = data.map(function (v) { return (v.f); });
        var maleArray = data.map(function (v) { return (v.m); });
        var array = femaleArray.concat(maleArray);
        var maxValue = Math.max.apply(Math, array);
        return maxValue;
    };
    InfluencerDemographicsComponent.prototype.mapData = function (data) {
        var result = Object.keys(data).map(function (key) { return ({ name: key, y: data[key] }); });
        return result;
    };
    /**
     * process raw data to get top 20 brand affinity without duplicated items
     * @param data
     */
    InfluencerDemographicsComponent.prototype.processBrandAffinityData = function (data) {
        // Transform data into {name, value} format
        var formatArray = Object.keys(data).map(function (key) { return Object.keys(data[key]).map(function (sub_key) { return ({
            name: sub_key,
            value: data[key][sub_key]
        }); }); });
        // Flatten an array of arrays
        var flatArray = formatArray.reduce(function (array, value) { return array.concat(value); }, []);
        // Filter duplicated items by name
        var filteredArray = flatArray
            .filter(function (value, index, array) {
            return array.findIndex(function (newValue) { return newValue.name === value.name; }) === index;
        }) // Remove duplicates from js array (ES5/ES6)  https://gist.github.com/telekosmos/3b62a31a5c43f40849bb
            .sort(function (a, b) { return b.value - a.value; })
            .slice(0, CommonConstant.BRAND_AFFINITY_TOP_ITEM);
        return filteredArray;
    };
    /**
     * calculate Top 10 Items for pie chart
     * @param data
     */
    InfluencerDemographicsComponent.prototype.calculateTopItem = function (data) {
        // Get max 10 items
        var selectedItems = data.slice(0, CommonConstant.PIE_CHART_TOP_ITEM);
        // Get the sum of percentage for selected items
        var totalPercent = selectedItems.reduce(function (accumulator, value) { return accumulator + value.y; }, 0);
        // Recalculate item percentages to be proportional to the sum of the top 10 items
        var calculatedItems = selectedItems.map(function (item) { return Object.assign(item, { y: (item.y * (100 / (totalPercent * 100))) }); });
        return calculatedItems;
    };
    /**
     * fill constanst name (language, country,...) by using code
     * @param data, constants
     */
    InfluencerDemographicsComponent.prototype.fillCodeConstanst = function (data, constants) {
        // create hash map constanst
        var constantsHash = constants.reduce(function (map, obj) { return (map[obj.code] = obj.name, map); }, {});
        // Assign data point code to get name from contanst hash
        var transformedData = data.map(function (item) { return Object.assign(item, {
            name: constantsHash[item.name]
        }); });
        return transformedData;
    };
    InfluencerDemographicsComponent.prototype.mapKeyInObjectIntoArray = function (data) {
        var result = Object.keys(data).map(function (key) { return key; });
        return result;
    };
    InfluencerDemographicsComponent.prototype.parseJSON = function (data) {
        var result = null;
        try {
            result = JSON.parse(data);
        }
        catch (error) {
            Sentry.captureException(error);
        }
        return result;
    };
    InfluencerDemographicsComponent.prototype.transformGenderPerAgeChartData = function (data) {
        var result = Object.keys(data).map(function (key) { return ({
            range: key,
            m: Math.round(data[key].MALE * 100),
            f: Math.round(data[key].FEMALE * 100)
        }); }).filter(function (line) { return line.f > 0 || line.m > 0; });
        return result;
    };
    InfluencerDemographicsComponent.prototype.getDemographicsData = function () {
        // no deep social data. Stop immediately
        if (!this.deepSocialData) {
            this.afterViewInit.emit(true);
            return;
        }
        this.rawChartData = {
            content_persons_statistic: this.parseJSON(this.deepSocialData.content_persons_statistic),
            content_geo_statistic: this.parseJSON(this.deepSocialData.content_geo_statistic),
            audience_interests: this.parseJSON(this.deepSocialData.audience_interests),
            audience_languages: this.parseJSON(this.deepSocialData.audience_languages),
            brand_affinity: this.parseJSON(this.deepSocialData.brand_affinity),
            audience_brand_affinity: this.parseJSON(this.deepSocialData.audience_brand_affinity),
        };
        if (this.rawChartData.content_persons_statistic) {
            this.genderChartData = this.mapData(this.rawChartData.content_persons_statistic.genders);
            for (var i = 0; i < this.genderChartData.length; i++) {
                if (this.genderChartData[i] && this.genderChartData[i].name === InfluencerDemographicGender.Male.toUpperCase()) {
                    this.genderChartData[i].name = InfluencerDemographicGender.Male;
                }
                if (this.genderChartData[i] && this.genderChartData[i].name === InfluencerDemographicGender.Female.toUpperCase()) {
                    this.genderChartData[i].name = InfluencerDemographicGender.Female;
                }
            }
            this.genderPerAgeChart = this.transformGenderPerAgeChartData(this.rawChartData.content_persons_statistic.gendersPerAge);
            this.genderPerAgeChartMaxPercent = InfluencerDemographicsComponent.getMaxPercentOfGenderPerAge(this.genderPerAgeChart);
        }
        if (this.rawChartData.content_geo_statistic) {
            this.countryChartData = this.calculateTopItem(this.mapData(this.rawChartData.content_geo_statistic.countries));
            this.countryChartData = this.fillCodeConstanst(this.countryChartData, this.countryList);
        }
        if (this.rawChartData.audience_interests) {
            this.audienceInterestChartData = this.calculateTopItem(this.mapData(this.rawChartData.audience_interests));
        }
        if (this.rawChartData.audience_languages) {
            this.nativeLanguageChartData = this.calculateTopItem(this.mapData(this.rawChartData.audience_languages));
            this.nativeLanguageChartData = this.fillCodeConstanst(this.nativeLanguageChartData, this.languageList);
        }
        if (this.rawChartData.audience_brand_affinity) {
            this.brandAffinityChartData = this.processBrandAffinityData(this.rawChartData.audience_brand_affinity);
        }
        this.isVisibleChart = true;
        this.afterViewInit.emit(true);
    };
    InfluencerDemographicsComponent.prototype.loadDefinitionData = function () {
        this.countryList = this.referenceDataService.countries;
        this.languageList = this.referenceDataService.languages;
        this.getDemographicsData();
    };
    Object.defineProperty(InfluencerDemographicsComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDemographicsComponent.prototype, "isAdmin", {
        get: function () {
            return this.userService.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDemographicsComponent.prototype, "fallbackTitle", {
        get: function () {
            if (this.userService.isFreeUser()) {
                return this.translate.instant('common.invalid_action_by_levels_warning.fallback_title');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDemographicsComponent.prototype, "fallbackMessage", {
        get: function () {
            if (this.userService.isFreeUser()) {
                return this.translate.instant('common.invalid_action_by_levels_warning.fallback_message');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    InfluencerDemographicsComponent.prototype.ngOnInit = function () {
        this.loadDefinitionData();
    };
    InfluencerDemographicsComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(InfluencerDemographicsComponent.COMPONENT_NAME);
    };
    InfluencerDemographicsComponent.COMPONENT_NAME = 'InfluencerDemographicsComponent';
    return InfluencerDemographicsComponent;
}());
export { InfluencerDemographicsComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/influencer-demographics.component.ts.pre-build-optimizer.js